export default function centsToDecimal(quantityInCents: number): number {
  return quantityInCents / 100
}
